export default "__VITE_ASSET__CERSWMSy__"